var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 126,
    viewBox: "0 0 161 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M105.655 40.25C105.655 46.9219 103.005 53.3204 98.2873 58.0382C93.5696 62.7559 87.171 65.4063 80.4991 65.4063C73.8273 65.4063 67.4287 62.7559 62.711 58.0382C57.9933 53.3204 55.3429 46.9219 55.3429 40.25C55.3429 33.5781 57.9933 27.1796 62.711 22.4618C67.4287 17.7441 73.8273 15.0938 80.4991 15.0938C87.171 15.0938 93.5696 17.7441 98.2873 22.4618C103.005 27.1796 105.655 33.5781 105.655 40.25ZM30.1934 134.958C30.4089 121.759 35.8038 109.172 45.2145 99.9142C54.6252 90.6559 67.2977 85.4673 80.4991 85.4673C93.7006 85.4673 106.373 90.6559 115.784 99.9142C125.195 109.172 130.589 121.759 130.805 134.958C115.023 142.195 97.8613 145.93 80.4991 145.906C62.5476 145.906 45.5085 141.989 30.1934 134.958Z",
    stroke: "#1B8379",
    strokeWidth: 15,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 439",
    cx: 81,
    cy: 40,
    r: 25,
    stroke: "#5F31EC",
    strokeWidth: 16
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/people-icon.7ed529b373943413ce8bdcde4f65c4c1.svg";
export { ForwardRef as ReactComponent };